// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2N4Su","resendInfoText":"OnGoingPaymentBox_resendInfoText__3L3Ex"};